import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/scholars";
import * as FActions from "../../../../../store/modules/footer";

class IntroForm extends Component {
  constructor(props) {
    super(props);

		this.state = {
      isFirst : this.props.record.intro == '' ? true : false
    }
  }

	onUpdate = () => {
		if(!this.state.isFirst) {
			func.updateData("admin/scholar/" + func.getParams("record_id") + "/intro/update", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
				} else {
					this.showMessage('저장 실패 : ' + response.message)
				}
			})
		} else {
			func.updateData("admin/scholar/" + func.getParams("record_id") + "/intro/insert", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					const url = func.changeParamUrl('record_id', response.scholar_id)
					let record = this.props.record;
					record.scholar_id = response.scholar_id;
					this.props.dataActions.setScholar({"record": record});
					func.pushUrl('레코드 아이디 넣기', url, null);
          this.setState({isFirst : false})
          // 렌더링을 시키고 싶은데...
          // console.log(this.props.record)
				} else {
					this.showMessage('저장 실패 : ' + response.return_message.message)
				}
			})
		}
	}

	useConfirm = (message = null, onConfirm, onCancel) => {
		if (!onConfirm || typeof onConfirm !== "function") {
			return;
		}
		if (onCancel && typeof onCancel !== "function") {
			return;
		}

		if (window.confirm(message)) {
			onConfirm();
		} else {
			onCancel();
		}
	}

	onDelete = () => {
		func.getParams("record_id") ? (
			this.useConfirm("삭제하시겠습니까?", this.deleteConfirm, this.cancelConfirm)
		) : (
			console.log("레코드 아이디가 없으면 삭제 불가능")
		)
	}

	deleteConfirm = () => {
    // api 에러남 삭제 필요한가?
		// func.updateData("admin/scholar/" + func.getParams("record_id") + "/intro/delete", this.props.record).then((response) => {
		// 	if (response.code === 'ok') {
		// 		this.showMessage('삭제 되었습니다.');
		// 	} else {
		// 		this.showMessage('삭제 실패 : ' + response.message)
		// 	}
		// })
	}
	
	cancelConfirm = () => this.showMessage('취소 되었습니다.');

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

  goLists = () => {
    const url = func.removeParamUrl('record_id')
    location.replace(url);
  }

  onChange = (e) => {
    console.log(e);
  };

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.dataActions.setScholar({"record": record});
	}

  render() {
    const {record} = this.props

    return (
      <>
		  <div className="d-flex justify-content-end mt-2 mb-1">
			  <h6 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1" style={{fontSize: "13px"}}>소개글</h6>
			  <button type="button" className="btn btn-sm btn-outline-primary" id="save_scholar" onClick={this.onInsert}>저장</button>
		  </div>
		  <form className="mt-1">
			  <div className="row mb-2">
				<div className="col-md-12 form-group">
                <textarea className="form-control" defaultValue={record.intro || ''}
						  name="intro"
						  ref={(ref)=>this.intro=ref}
						  onChange={this.textEvent}
						  placeholder="저자의 소개글을 작성해 주세요."
				/>
				</div>
			  </div>
		  </form>
      </>
    )
  }
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
) (IntroForm)